import Spring from '@/assets/graphical-elements/spring.svg'
import {cn} from '@/lib/utils'
import {type IconProps} from '../types'

export const SpringIcon = ({className}: IconProps) => <Spring className={cn('fill-current', className)} />
